import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M12.36 19a.15.15 0 0 1 0-.17.16.16 0 0 1 .15-.09 1 1 0 0 0 0-2H2.5a.5.5 0 0 1-.5-.5V4.75a.5.5 0 0 1 .5-.5H19a.5.5 0 0 1 .5.5v.5a1 1 0 0 0 2 0v-1a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12.5a2 2 0 0 0 2 2h6.35a.25.25 0 0 1 .22.13.27.27 0 0 1 0 .26L7.33 21a.5.5 0 0 0 .42.78h5.5a.5.5 0 0 0 .42-.78Z" }),
      createElementVNode("path", { d: "M23 7.75h-7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1M22 11h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 0 1.5m.25 7.75a.76.76 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h4a.76.76 0 0 1 .75.75" })
    ], -1)
  ]));
}
const computerDeviceDesktop = { render };
export {
  computerDeviceDesktop as default,
  render
};
//# sourceMappingURL=computer-device-desktop.svg.js.map
